import { render } from "./CaseStudiesSection.vue?vue&type=template&id=5a3e5046&scoped=true"
const script = {}

import "./CaseStudiesSection.vue?vue&type=style&index=0&id=5a3e5046&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3e5046"]])

export default __exports__